export default __webpack_public_path__ + "static/media/130.c60244d3.jpg";